/* Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';
import { Fragment } from 'react';

const CSATEmojiesSvg = (
  index
) => {

  let emojiRect = '';
  switch(index) {
    case 1:
      emojiRect = <Fragment>
        <g clip-path="url(#clip0_709_9430)">
          <rect x="0.5" y="0.5" width="17" height="17" fill="#EE5E31"/>
          <circle cx="6.5" cy="7.5" r="1" fill="#913111"/>
          <circle cx="11.5" cy="7.5" r="1" fill="#913111"/>
          <path d="M5.5 12.5001C7 9.49998 11 9.5 12.5 12.5001" stroke="#913111" stroke-width="0.8" stroke-linecap="round"/>
        </g>
        <defs>
          <clipPath id="clip0_709_9430">
            <rect x="0.5" y="0.5" width="17" height="17" rx="3" fill="white"/>
          </clipPath>
        </defs>
      </Fragment>;
      break;
    case 2:
      emojiRect = <Fragment>
        <g clip-path="url(#clip0_709_9494)">
          <rect x="0.5" y="0.5" width="17" height="17" fill="#FFD15A"/>
          <circle cx="6.5" cy="7.5" r="1" fill="#A78322"/>
          <circle cx="11.5" cy="7.5" r="1" fill="#A78322"/>
          <path d="M5.5 12.5L12.5 12.5" stroke="#A78322" stroke-width="0.8" stroke-linecap="round"/>
        </g>
        <defs>
          <clipPath id="clip0_709_9494">
            <rect x="0.5" y="0.5" width="17" height="17" rx="3" fill="white"/>
          </clipPath>
        </defs>
      </Fragment> ;
      break;
    case 3:
      emojiRect = <Fragment>
        <g clip-path="url(#clip0_709_9558)">
          <rect x="0.5" y="0.5" width="17" height="17" fill="#81DA95"/>
          <circle cx="6.5" cy="7.5" r="1" fill="#3C814C"/>
          <circle cx="11.5" cy="7.5" r="1" fill="#3C814C"/>
          <path d="M12.5 10.2499C11 13.25 7 13.25 5.5 10.2499" stroke="#3C814C" stroke-width="0.8" stroke-linecap="round"/>
        </g>
        <defs>
          <clipPath id="clip0_709_9558">
            <rect x="0.5" y="0.5" width="17" height="17" rx="3" fill="white"/>
          </clipPath>
        </defs>
      </Fragment>;
      break;
    default:
      break;
  }
  return (
    <svg width="1.5em" height="1.5em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      {emojiRect}
    </svg>
  );
};

export const CSATEmojiesIcon = ({ index, ...props }) => (
  <Icon component={() => CSATEmojiesSvg(index)} {...props} />
);

CSATEmojiesIcon.propTypes = {
  index: PropTypes.number
};
